import { metricsForPQLesson, metricsForPF, sortMetrics } from './metrics';

const getPQ1Header = (title) => {
    return [
        [title],
        ['',
            '',
            'Phonemic Awareness',
            'Grapheme Formation',
            'Grapheme Formation',
            'Phonics',
            'Decoding',
            'Encoding',
            'Oral Reading Fluency'],
        ['Name',
            'Lesson',
            'Sound Farm',
            'Trace Race 1',
            'Trace Race 2',
            'Sound Blend Activity 1',
            'Sound Blend Activity 2',
            'Really Writing',
            'Really Reading'],
        ['',
            '',
            '# of correctly\nrecognized target\nsounds (out of 5)',
            '# of tries for student\nto write target\nsound 5 times\nwithin time limit',
            '# of tries for student\nto write target\nsound 5 times\nwithin time limit',
            '# of target letters\nformed correctly in\n3 words (chosen at\nrandom so #\'s will vary)',
            '# of words read\ncorrectly (out\nof 3) Speech\nrecognition setting\nmust be on',
            '# of full words written\ncorrectly (out of 3)',
            'Audio scored by teacher\n(Teacher Evaluation\nmode only']
    ];
};

const getPQ2Header = (title) => {
    return [
        [title],
        ['',
            '',
            'Phonemic Awareness',
            'Word Recognition',
            'Grapheme Formation',
            'Grapheme Formation',
            'Phonics',
            'Decoding',
            'Encoding',
            'Oral Reading Fluency'],
        ['Name',
            'Lesson',
            'Sound Farm',
            'Word Builder',
            'Trace Race 1',
            'Trace Race 2',
            'Sound Blend Activity 1',
            'Sound Blend Activity 2',
            'Really Writing',
            'Really Reading'],
        ['',
            '',
            '# of correctly\nrecognized target\nsounds (out of 5)',
            '# of word parts\ncorrectly paired\non first try',
            '# of tries for student\nto write target\nsound 5 times\nwithin time limit',
            '# of tries for student\nto write target\nsound 5 times\nwithin time limit',
            '# of target letters\nformed correctly in\n3 words (chosen at\nrandom so #\'s will vary)',
            '# of words read\ncorrectly (out\nof 3) Speech\nrecognition setting\nmust be on',
            '# of full words written\ncorrectly (out of 3)',
            'Audio scored by teacher\n(Teacher Evaluation\nmode only']
    ];
};

const getPFHeader = (title) => {
  return [
    [title],
    ['Name', 'Target/Activity', 'Lesson/Phoneme', 'Sound Farm (passed 1st attempt)', 'Sound Game (passed 2nd attempt)']
  ];
};

export const generateCSVPQ1 = (classroom, students) =>{
    let returnData = getPQ1Header(`Classroom: ${classroom.name}`);
    students.forEach( (studentItem) => {
        if(studentItem.metrics){
            sortMetrics(studentItem.metrics).forEach((lesson) => {
                let data = metricsForPQLesson(lesson);
                returnData.push([
                    studentItem.name,
                    lesson.name,
                    data.sf.two.text,
                    data.tr.one.text,
                    data.tr.two.text,
                    data.sb.one.text,
                    data.sb.two.text,
                    data.rw.two.text,
                    data.rr.one.text
                ]);
            });
        }
    });
    return returnData;
};


export const generateCSVPQ2 = (classroom, students) =>{
    let returnData = getPQ2Header(`Classroom: ${classroom.name}`);
    students.forEach( (studentItem) => {
        if(studentItem.metrics) {
            sortMetrics(studentItem.metrics).forEach((lesson) => {
                let data = metricsForPQLesson(lesson);
                returnData.push([
                    studentItem.name,
                    lesson.name,
                    data.sf.two.text,
                    data.wb.one.text,
                    data.tr.one.text,
                    data.tr.two.text,
                    data.sb.one.text,
                    data.sb.two.text,
                    data.rw.two.text,
                    data.rr.one.text
                ]);
            });
        }
    });

    return returnData;
};

const getDisplayText = (scoreJson) => {
    return `${scoreJson.score}/${scoreJson.outOf}`;
};

export const generateCSVPF = (classroom, students) => {
    let returnData = getPFHeader(`Classroom: ${classroom.name}`);
    students.forEach( (studentItem) => {
        if(studentItem.metrics){
            let data = metricsForPF(sortMetrics(studentItem.metrics));
            if(data.tractor.length > 0){
                data.tractor.forEach((item) => {
                    if (item.soundfarm1json && item.tractor1json) {
                        returnData.push([studentItem.name, 'Initial Vowel - Tractor', item.name, getDisplayText(item.soundfarm1json), getDisplayText(item.tractor1json)]);
                    } else {
                        returnData.push([studentItem.name, 'Initial Vowel - Tractor', item.name, item.soundfarm1, item.tractor1]);
                    }
                });
            }
            if(data.horse.length > 0){
                data.horse.forEach((item) => {
                    if (item.soundfarm1json && item.horse1json) {
                        returnData.push([studentItem.name, 'Initial Consonant - Horseshoe', item.name, getDisplayText(item.soundfarm1json), getDisplayText(item.horse1json)]);
                    } else {
                        returnData.push([studentItem.name, 'Initial Consonant - Horseshoe', item.name, item.soundfarm1, item.horse1]);
                    }
                });
            }
            if(data.apple.length > 0){
                data.apple.forEach((item) => {
                    if (item.soundfarm1json && item.apple1json) {
                        returnData.push([studentItem.name, 'Initial Consonant - Apple', item.name, getDisplayText(item.soundfarm1json), getDisplayText(item.apple1json)]);
                    } else {
                        returnData.push([studentItem.name, 'Initial Consonant - Apple', item.name, item.soundfarm1, item.apple1]);
                    }
                });
            }
            if(data.sheep.length > 0){
                data.sheep.forEach((item) => {
                    if (item.soundfarm1json && item.sheep1json) {
                        returnData.push([studentItem.name, 'Final Consonant - Sheep', item.name, getDisplayText(item.soundfarm1json), getDisplayText(item.sheep1json)]);
                    } else {
                        returnData.push([studentItem.name, 'Final Consonant - Sheep', item.name, item.soundfarm1, item.sheep1]);
                    }
                });
            }
            if(data.popcorn.length > 0){
                data.popcorn.forEach((item) => {
                    if (item.soundfarm1json && item.popcorn1json) {
                        returnData.push([studentItem.name, 'Final Consonant - Popcorn', item.name, getDisplayText(item.soundfarm1json), getDisplayText(item.popcorn1json)]);
                    } else {
                        returnData.push([studentItem.name, 'Final Consonant - Popcorn', item.name, item.soundfarm1, item.popcorn1]);
                    }
                });
            }
            if(data.egghay.length > 0){
                data.egghay.forEach((item) => {
                    if (item.soundfarm1json && item.egg1json && item.hay1json) {
                        returnData.push([studentItem.name, 'Final Consonant - Egg/Hay', item.name, getDisplayText(item.soundfarm1json), getDisplayText(item.egg1json), getDisplayText(item.hay1json)]);
                    } else {
                        returnData.push([studentItem.name, 'Final Consonant - Egg/Hay', item.name, item.soundfarm1, item.egg1, item.hay1]);
                    }
                });
            }
            if(data.manipulation.length > 0){
                data.manipulation.forEach((item) => {
                    if (item.soundfarm1json && item.manipulation1json) {
                        returnData.push([studentItem.name, 'Dunk Tank', item.name, getDisplayText(item.soundfarm1json), getDisplayText(item.manipulation1json)]);
                    } else {
                        returnData.push([studentItem.name, 'Dunk Tank', item.name, item.soundfarm1, item.manipulation1]);
                    }
                });
            }
            if(data.deletion.length > 0){
                data.manipulation.forEach((item) => {
                    if (item.soundfarm1json && item.deletion1json) {
                        returnData.push([studentItem.name, 'Milk Bottle Toss', item.name, getDisplayText(item.soundfarm1json), getDisplayText(item.deletion1json)]);
                    } else {
                        returnData.push([studentItem.name, 'Milk Bottle Toss', item.name, item.soundfarm1, item.deletion]);
                    }
                });
            }
        }
    });
    return returnData;
};




// WEBPACK FOOTER //
// ./js/util/csv.js